
import {finalize} from 'rxjs/operators';
// angular
import { Component, Inject, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../core/auth.service';
import { PatientsService } from '../../patients/patients.service';
import { BaseService } from '../../shared/base.service';
import { AppService } from '../../app.service';
import {ModalDirective} from 'ngx-bootstrap/modal';
import { QuestionnairesService } from '../questionnaires/questionnaires.service';
import { SecureApi } from '../../core/secure.api';
import { DialogComponent } from '../../dialog/dialog.component';
import { PatientComponent } from '../patient.component';
import { PatientService } from '../patient.service';
import { PatientQuestionnairesComponent } from '../patient-questionnaires/patient-questionnaires.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    templateUrl: 'contact-patient-modal.component.html',
    styleUrls: ['contact-patient-modal.component.scss']
})

export class ContactPatientComponent extends PatientQuestionnairesComponent implements OnInit, AfterViewInit {

    type: string;
    url = 'patients';
    errorMessage = [];
    successMessage = '';
    formSubmitted = false;
    params: any = {};
    queryParams = {};
    form: FormGroup;
    doctors: Object[];
    assistants: Object[];
    mpa: Object[];
    creationDate: string;
    date: Date;
    age: number;
    languages: Object[];
    questionnaires: any;
    CONTACTTypes = [
        {
            'title' : 'Book appointment',
            'createTitle': 'Book appointment',
            'name': 'appointment',
            'template_name': 'booking_templates',
            'label' : 'Book appointment',
            'type'  : 'book_appointment',
            'action': 'Book appointment',
            'route': '',
            'disabled' : false,
        },{
            'title' : 'Invitation link to the call',
            'createTitle': 'Invitation link to the call',
            'name': 'invitation',
            'template_name': 'invitation_templates',
            'label' : 'Invitation link to the call',
            'type'  : 'invitation_link',
            'action': 'Invitation link to the call',
            'route': '',
            'disabled' : false,
        },{
            'title' : 'Request from your Klenico therapist',
            'createTitle': 'E-Mail without draft',
            'name': 'contact',
            'template_name': 'contact',
            'label' : 'Contact',
            'type'  : 'contact',
            'action': 'Contact',
            'route': '',
            'disabled' : false,
        }
    ];
    activeCONTACTType = this.CONTACTTypes[0];
    emailsContent = {
        book_appointment: {
            content: ''
        },
        invitation_link: {
            content: ''
        },
        contact: {
            content: ''
        },
    };
    activeQuestionnaireId = null;
    userRoleId: number;

    emailModel: string;

    // @ViewChild('revocationPop', { static: false }) revocationPop: PopoverDirective;
    @ViewChild('modal', { static: false }) public modal: ModalDirective;
    @ViewChild('dialog', { static: true }) dialog: DialogComponent;
    @Input() patientId: number;

    formLoading: boolean;
    patient: any;
    latestId: any;
    questionnaireEmailTemplates: Object[] = [];
    repeatedQuestionnaireEmailTemplates: Object[] = [];
    selectedTemplateTranslationId: number = 0;
    regexForQuestionnaireTag = /<a\s+(?:[^>]*?\s+)?title=['"]?questionnaire-link["'](.*?)\1/;
    _noActiveQuestionnaire = false;

    languageId: number;
    // Email templates
    bookingTemplate: any;
    invitationTemplate: any;


    constructor(public fb: FormBuilder,
        public secureApi: SecureApi,
        public authService: AuthService,
        public route: ActivatedRoute,
        public baseService: BaseService,
        public patientsService: PatientsService,
        public appService: AppService,
        public router: Router,
        public patientService: PatientService,
        public translate: TranslateService,
        public questionnairesService: QuestionnairesService,
        @Inject(PatientComponent) public parent: PatientComponent,
    ) {
        super(appService, authService, baseService, questionnairesService, patientService,fb, patientsService, route, translate, router);
    }

    ngOnInit() {
        this.type = this.route.snapshot.data['type'];
        this.formLoading = true;
        this.route.params.subscribe(params => {
            this.params = this.route.parent.snapshot.params;
            this.patientId = this.params['id'] ? this.params['id'] : params['patientId'];
            this.appService.isLoading = true;
        });

        this.route.queryParams.subscribe(queryParams => {
            this.activeQuestionnaireId = queryParams['archive'];
            this.queryParams = queryParams;
        });
    }

    ngAfterViewInit() {
        this.modal.config.ignoreBackdropClick = true;
        this.modal.config.backdrop = false;
        this.modal.config.keyboard = false;
        return this.openQuestionnaireModal();
    }

    buildForm(type): void {
        this.form = this.fb.group({
            patient_id: [{ value: null }],
            email: [''],
            content: ['', [<any>Validators.required]],
            email_subject: [{ value: '' }],
            email_header: [{ value: '' }],
        });
    }

    createFormModal() {
        this.patientsService.read(this.params['id']).pipe(
            finalize(() => {
                this.appService.isLoading = false;
                this.formLoading = false;
            }))
            .subscribe(
                response => {
                    this.patient = response['patient'];
                    this.patientId = this.patient.id;
                    this.languages = response['languages'];
                    this.form.controls['patient_id'].setValue(this.patientId);
                    this.form.controls['email'].disable();

                    if (this.patient.language_id) {
                        this.form.controls['language_id'].setValue(this.patient.language_id);
                    } else {
                        this.form.controls['language_id'].setValue(response['default_language']);
                    }
                }
            );
    }

    showModal() {
        this.formLoading = false;
        this.appService.isLoading = false;
        this.modal.show();
    }

    hideModal() {
        this.modal.hide();
        if (this.params && this.params['id']) {
            return this.router.navigate(['patient/' + this.patientId]);
        }
        return this.router.navigate(['patients']);
    }

    /**
     * @param patientModel
     * @param {boolean} isValid
     */
    submit(patientModel: any, isValid: boolean) {

        this.form.controls['content'].setValue(this.emailsContent[this.activeCONTACTType.type]);
        if (!isValid) {
            this.formSubmitted = true;
            return;
        }
        this.resetErrors();
        this.patientService.sendEmail(this.patientId, this.form.value)
            .subscribe(
                response => {
                    this.isLoading = false;
                    let _self = this;
                    this.formSubmitted = true;
                    this.successMessage = response['message'];
                    setTimeout(function () {
                        return _self.hideModal();
                    },2000);
                },error => {
                    this.errorMessage = this.appService.parseErrors(error);
                }
            );
    }

    resetErrors() {
        if (this.errorMessage.length > 0) {
            this.errorMessage = [];
        }
    }

    get isDoctorCreating() {
        return this.authService.isDoctor;
    }

    /**
     * Open Add/Send questionnaire form
     * @param {Object} params
     */
    openQuestionnaireModal() {
        /**
         * Define form open questionnaire
         * @type {FormGroup}
         */
        this.buildForm(this.activeCONTACTType.type);
        /**
         * Get user info and set default value
         */
        if (!this.patientId) {
            return this.hideModal();
        }
        this.patientService.getBookingEmailTemplate(this.patientId)
            .subscribe(
                response => {
                    this.bookingTemplate = response['booking_templates'];
                    this.invitationTemplate = response['invitation_templates'];

                    /**
                     * Parse email template by language
                     */
                    this.languageId = response['language_id'] || 1;
                    let bookingByLanguage = [];
                    let invitationByLanguage = [];
                    if (response['booking_templates']) {
                        bookingByLanguage = this.getTemplateTranslation(this.bookingTemplate, this.languageId);
                    }

                    let _self = this;
                    this.CONTACTTypes.forEach(function (contactType) {
                        const responseTemplate = response[contactType.template_name] || '';
                        const content =  responseTemplate ? _self.getTemplateTranslation(responseTemplate, _self.languageId) : '';
                        _self.emailsContent[contactType.type] = content ? content[0][0]['content'] : '';
                    });
                    this.form.controls['content'].setValue(bookingByLanguage[0][0]['content']);
                    this.form.controls['email_subject'].setValue(bookingByLanguage[0][0]['email_subject']);
                    this.form.controls['email_header'].setValue(bookingByLanguage[0][0]['email_header']);
                    this.form.controls['patient_id'].setValue(this.patientId);

                    this.questionnaireEmailTemplates = [].concat.apply(bookingByLanguage, invitationByLanguage);
                    
                    this.form.controls['email'].setValue(response['email'] || '');
                    this.form.controls['email'].disable();

                    this.showModal();
                },
                error => {
                    this.errorMessage = this.appService.parseErrors(error);
                    this.modal.hide();
                    this.openAlertModal({icon: 'fas fa-exclamation-triangle', warning: true}, this.errorMessage);
                }
            );
    }

    getTemplateTranslation(templates, languageId) {
        return templates.map(template => template.translations.filter(function (translation) {
            return translation.language_id === languageId;
        }));
    }

    changecontactType(type) {
        let selectedTemplate = this;
        let templateTranslation: any;
        switch (type) {
            case 'book_appointment':
                templateTranslation = this.getTemplateTranslation(this.bookingTemplate, this.languageId);
                this.activeCONTACTType = this.CONTACTTypes[0];
                selectedTemplate = templateTranslation[0][0];
                break;
            case 'invitation_link':
                templateTranslation = this.getTemplateTranslation(this.invitationTemplate, this.languageId);
                this.activeCONTACTType = this.CONTACTTypes[1];
                selectedTemplate = templateTranslation[0][0];
                break;
            default:
                this.activeCONTACTType = this.CONTACTTypes[2];
                this.form.controls['email_subject'].setValue(this.translate.instant(this.activeCONTACTType['title']));
                this.form.controls['email_header'].setValue(this.translate.instant(this.activeCONTACTType['title']));
                return;
        }

        this.form.controls['email_subject'].setValue(selectedTemplate['email_subject']);
        this.form.controls['email_header'].setValue(selectedTemplate['email_header']);
    }

    openAlertModal(params: Object, errorMessage: any) {
        const dialog = this.dialog.openAlert(params);
        dialog.showAlert(errorMessage[0]);
    }

    changeCONTACTType(CONTACTType) {
        if(CONTACTType.disabled) {
            return false;
        }
        this.activeCONTACTType = CONTACTType;

        if(CONTACTType.type === 'appointment' || CONTACTType.type === 'invitation_link') {
            this.form.controls['email'].setValidators([<any>Validators.required,
                <any>Validators.pattern('[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}')]);
            const email = (this.patient && this.patient.email) ? this.patient.email : null;
            this.form.controls['email'].setValue(email);
        } else {
            this.form.get('email').clearValidators();
            this.form.get('email').updateValueAndValidity();
        }
    }
}
